/* eslint no-dupe-keys: 0 */
import { filterCriteria as creditMemoFilterCriteria } from "@/views/CreditMemo/inputs";

import * as Entities from "@/resources/Entities";

export const ccpColumns = [
  {
    id: "select",
    type: "button",
    action: "selectItem",
    position: "sticky",
    iconName: "hand-pointer",
    ariaLabel: "Open",
  },
  {
    title: "Memo Type",
    id: "memoType",
  },
  {
    title: "Balance",
    id: "memoBalance",
  },
  {
    title: "Used",
    id: "memoAmountUsed",
  },
  {
    title: "Total",
    id: "memoTotal",
  },
  {
    title: "Starting Date",
    id: "ccpStartDate",
    type: "date",
  },
  {
    title: "Ending Date",
    id: "ccpExpirationDate",
    type: "date",
  },
  {
    title: "Id",
    id: "_id",
  },
  {
    title: "Customer #",
    id: "customer._id",
  },
];

export const inputs = [
  {
    id: "ccp",
    placeholder: "Select CCP",
    type: "search",
    title: "CCP",
    label: "name",
    class: "grid-row-two-column",
    entity: Entities.CREDITMEMO,
    columnHeaders: ccpColumns,
    filterCriteria: creditMemoFilterCriteria,
    isClearable: true,
    fieldsToDisplay: [{ label: "Id", id: "_id" }],
  hideFilter: true,
    filter: {
      memoType: "CCP",
      memoBalance: { $gt: 0 },
      isPostedToJournal: true,
      isArchived: false,
      $and: [
        {
          $or: [
            {
              ccpExpirationDate: { $exists: false },
            },
            {
              ccpExpirationDate: null,
            },
            {
              ccpExpirationDate: { $gt: new Date() },
            }
          ],
        },
        {
          ccpStartDate: { $lte: new Date() },
        },
      ],
    },
  },
];
